import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from '@angular/router';
import { PagingComponent } from './components/paging/paging.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ProductReviewComponent } from './components/product-review/product-review.component';
import { NgxStarsModule } from 'ngx-stars';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FilterComponent } from './components/all-filters/filter/filter.component';
import { UnboxFilterComponent } from './components/all-filters/unbox-filter/unbox-filter.component';
import { ChangelebelsPipe } from './changelebels.pipe';

const components=[
    HeaderComponent,
    FilterComponent,
    UnboxFilterComponent,
    BreadcrumbComponent,
    ProductReviewComponent,
    PagingComponent,
    ChangelebelsPipe,
]

@NgModule({
  declarations: [
    components,
    ErrorPageComponent,
    ProductReviewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    RouterModule,NgxStarsModule,NgxSliderModule,
    RouterModule,NgxPaginationModule
  ],
  exports:[
    components
  ] ,
   schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],

})
export class SharedModule { }
